import script from "./FordConfigWorkspace.vue?vue&type=script&setup=true&lang=js"
export * from "./FordConfigWorkspace.vue?vue&type=script&setup=true&lang=js"

import "./FordConfigWorkspace.vue?vue&type=style&index=0&id=4084ab00&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4084ab00"]])

export default __exports__